// orders
export const GET_USER_ORDERS = 'GET_USER_ORDERS'
export const GET_USER_ORDERS_SUCCESS = 'GET_USER_ORDERS_SUCCESS'
export const GET_USER_ORDERS_FAILURE = 'GET_USER_ORDERS_FAILURE'
